<template>
  <div class="container data-validation">
    <div class="data-section">
      <div class="data-group inlined">
        <h4>Nombre</h4>
        <p>{{this.$props.userData.names}}</p>
      </div>
      <div class="data-group inlined">
        <h4>Apellido</h4>
        <p>{{this.$props.userData.last_names}}</p>
      </div>
      <div class="data-group">
        <h4>Fecha de Nacimiento</h4>
        <p>{{this.$props.userData.birthdate}}</p>
      </div>
      <div class="data-group">
        <h4>Lugar de Nacimiento</h4>
        <p>{{this.$props.userData.country_birth}}</p>
      </div>
      <div class="data-group">
        <h4>Nacionalidad</h4>
        <p>{{this.$props.userData.nationality}}</p>
      </div>
      <div :class="{'no-bottom-margin': showSaveAddressAsIs}" class="data-group">
        <h4 style="margin-bottom: 4px;">
          Domicilio
        </h4>
        <div v-show="isEditing && showSaveAddressAsIs" style="margin-top: 0px;" class="data-group">
          <input id="address-not-found" name="address-not-found" type="checkbox" @change="addressNotFoundChanged" v-model="addressNotFound">
          <label for="address-not-found" style="font-size: 12px;">¿No encontrás tu dirección?</label>
        </div>
        <p v-show="!isEditing">{{address}}</p>
        <input v-show="isEditing" id="address-edit-field" style="margin-bottom: 4px;"
        type="text" ref="autocomplete" placeholder="Ingresar Dirección" v-model="address" @keydown="addressKeyDown" />
        <p v-show="addressNotFound" style="font-size: 13px;">Ingresá tu dirección acá arriba</p>
        <input v-show="isEditing" id="floor-edit-field"
        type="text" placeholder="Piso" v-model="floor" />
        <input v-show="isEditing" id="apt-edit-field"
        type="text" placeholder="Dpto." v-model="apartment" />
      </div>
      <button @click="confirmDetails">¡Sí, está correcto!</button>
      <p v-if="error" style="color: red;">{{error}}</p>
      <a class="go-back-link" href="#" @click.prevent="editAddress">
        {{ isEditing ? 'Cancelar Edición' : 'No, editar mi domicilio'}}
      </a>
      <img class="imagen" src="../assets/images/logo-renaper.png" alt="Logo Renaper">
      <p style="font-size: 11px;">Verificá que los datos sean los correctos, de lo contrario <a target="_blank" href="https://www.argentina.gob.ar/interior/registro-nacional-de-las-personas">comunicate con Renaper</a></p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CONSTANTS from '@/constants';

const ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'long_name',
  administrative_area_level_2: 'long_name',
  country: 'long_name',
  postal_code: 'short_name',
};
// const CITIES_TYPE = ['locality', 'administrative_area_level_3'];
// const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
  // 'administrative_area_level_1', 'administrative_area_level_2'];

export default {
  name: 'data-validation',
  data() {
    return {
      autocompleteFieldId: 'address-edit-field',
      address: '',
      preloadedAddress: '',
      floor: '',
      apartment: '',
      formattedAddress: {},
      isEditing: false,
      hasEdited: false,
      formattedPlace: {},
      preloadedAddressFormatted: {},
      autocompleteLsr: {},
      autocomplete: {},
      error: '',
      strikes: 0,
      showSaveAddressAsIs: false,
      addressNotFound: false,
    };
  },
  props: {
    token: String,
    loggedIn: Boolean,
    user: Object,
    userData: Object,
    screen: Number,
  },
  watch: {
    address(newValue, oldValue) {
      if (newValue.length < oldValue.length) {
        this.strikes += 1;
      }
      if (this.strikes >= 3) {
        this.showSaveAddressAsIs = true;
      }
    },
    addressNotFound(newValue) {
      if (newValue) {
        this.address = '';
        document.querySelector('body').classList.add('hide-pac-container');
      } else if (document.querySelector('body').classList.contains('hide-pac-container')) {
        document.querySelector('body').classList.remove('hide-pac-container');
      }
    },
    userData() {
      if (!(Object.entries(this.$props.userData).length === 0 && this.$props.userData.constructor === Object)) {
        console.log('User Data Changed');
        const { province } = this.$props.userData;
        if (this.$props.userData.street_address === '' || this.$props.userData.street_address === '' || this.$props.userData.municipality === '' || this.$props.userData.municipality === '') {
          this.isEditing = true;
        } else {
          const userSubpremise = this.$props.userData.floor !== '' ? `, ${this.$props.userData.floor} ${this.$props.userData.department}` : '';
          this.address = `${this.$props.userData.street_address} ${this.$props.userData.street_number}${userSubpremise}, ${this.$props.userData.municipality}, ${province}, ${this.$props.userData.country}`;
        }
      }
    },
    floor(newValueFloor) {
      if (Object.entries(this.formattedAddress).length === 0 && this.formattedAddress.constructor === Object) {
        return;
      }
      this.formattedAddress.floor = newValueFloor;
    },
    apartment(newValueApartment) {
      if (Object.entries(this.formattedAddress).length === 0 && this.formattedAddress.constructor === Object) {
        return;
      }
      this.formattedAddress.apartment = newValueApartment;
    },
  },
  methods: {
    addressKeyDown(e) {
      const eventKey = e.key ? e.key : false;
      if (eventKey === 'Enter') {
        return;
      }
      if (eventKey === 'Tab') {
        return;
      }
      const unicode = e.keyCode ? e.keyCode : e.charCode;
      if (unicode === 13) {
        return;
      }
      if (unicode === 9) {
        return;
      }
      console.log(e);
      this.formattedAddress = {};
    },
    addressNotFoundChanged() {
      this.error = '';
    },
    confirmDetails() {
      this.error = '';
      if (!this.address) {
        this.error = 'Verificá tu dirección';
        return;
      }
      this.setIsLoading();
      if (!this.isEditing) {
        this.formattedAddress = {
          street_address: this.$props.userData.street_address,
          street_number: this.$props.userData.street_number,
          floor: this.$props.userData.floor !== '' ? `${this.$props.userData.floor}` : '',
          apartment: this.$props.userData.department !== '' ? `${this.$props.userData.department}` : '',
          postal_code: this.$props.userData.postal_code,
          city: this.$props.userData.city,
          municipality: this.$props.userData.municipality,
          province: this.$props.userData.province,
          country_code: 1,
        };
        this.uploadAddress();
      } else {
        if (this.addressNotFound) {
          this.updateUser();
          return;
        }
        if (Object.entries(this.formattedAddress).length === 0 && this.formattedAddress.constructor === Object) {
          this.error = 'Seleccioná tu dirección del listado';
          this.setIsLoading(false);
          return;
        }
        this.uploadAddress();
      }
    },
    editAddress() {
      this.error = '';
      if (this.isEditing) {
        const oldAddress = this.preloadedAddress;
        this.address = oldAddress;
      } else {
        const oldAddress = this.address;
        this.preloadedAddress = oldAddress;
        this.address = '';
      }
      this.formattedAddress = {};
      this.isEditing = !this.isEditing;
      // document.getElementById('address-edit-field').focus();
    },
    uploadAddress() {
      const data = JSON.stringify(this.formattedAddress);
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user-addresses/`,
      };
      // console.log(options);
      axios(options)
        .then((/* result */) => {
          // console.log(result);
          this.updateUser();
        })
        .catch((error) => {
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('uploadAddress', { loggedIn: this.$props.loggedIn, email });
        });
    },
    updateUser() {
      let failedInputAddress = false;
      let livingAddress = this.address;
      if (this.addressNotFound) {
        failedInputAddress = true;
        livingAddress = `${this.address} ${this.floor}${this.apartment}`;
      } else if (this.isEditing) {
        const userSubpremise = this.floor !== '' ? `, ${this.floor} ${this.apartment}` : '';
        livingAddress = `${this.address}${userSubpremise}`;
      }
      const data = JSON.stringify({
        living_address: livingAddress,
        failed_input_address: failedInputAddress,
      });
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user/profile/`,
      };
      console.log(options);
      axios(options)
        .then((result) => {
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          window.gtag('event', 'submit', {
            event_category: 'paso3',
            event_label: email,
          });
          const user = result.data;
          this.$emit('user-updated', user);
          this.$emit('advance-screen', 3);
        })
        .catch((error) => {
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('updateUser', { loggedIn: this.$props.loggedIn, email });
        });
    },
    previousPage() {
      this.$emit('advance-screen', 1);
    },
    setIsLoading(loading = true) {
      this.$emit('is-loading', loading);
    },
    onPlaceChanged() {
      const place = this.autocomplete.getPlace();
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        console.log(place);
        return;
      }
      if (place.address_components !== undefined) {
        this.address = place.formatted_address;
        this.formattedPlace = this.formatResult(place);
      }
    },
    formatResult(place) {
      const returnData = {};
      for (let i = 0; i < place.address_components.length; i += 1) {
        const addressType = place.address_components[i].types[0];
        if (ADDRESS_COMPONENTS[addressType]) {
          const val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
          returnData[addressType] = val;
        }
      }
      this.formattedAddress = {
        /* street_address: this.$props.userData.street_address,
        street_number: Number(this.$props.userData.street_number),
        postal_code: this.$props.userData.postal_code,
        city: this.$props.userData.city,
        municipality: this.$props.userData.municipality,
        province: this.$props.userData.province, */
        country_code: 1,
      };

      if (typeof returnData.route !== 'undefined') {
        this.formattedAddress.street_address = returnData.route;
      }
      if (!Number.isNaN(Number(returnData.street_number))) {
        this.formattedAddress.street_number = returnData.street_number;
      }
      if (typeof returnData.postal_code !== 'undefined') {
        this.formattedAddress.postal_code = returnData.postal_code;
      }
      if (typeof returnData.administrative_area_level_2 !== 'undefined') {
        this.formattedAddress.city = returnData.administrative_area_level_2;
      }
      if (typeof returnData.locality !== 'undefined') {
        this.formattedAddress.municipality = returnData.locality;
      }
      if (typeof returnData.administrative_area_level_1 !== 'undefined') {
        this.formattedAddress.province = returnData.administrative_area_level_1;
      }

      // TODO: Verify that all addresses are correct and they exist in returnData object
      returnData.latitude = place.geometry.location.lat();
      returnData.longitude = place.geometry.location.lng();
      return returnData;
    },
  },
  mounted() {
    /* We redirect to log in screen if not logged in */
    if (!this.$props.loggedIn) this.$router.push({ name: 'basic-info' });
    if (this.$props.screen !== 2) this.$emit('advance-screen-protect', this.$props.screen);
    window.gtag('config', 'UA-140392151-1', {
      page_title: 'paso3',
      page_path: '/data',
    });
    if (!(Object.entries(this.$props.userData).length === 0 && this.$props.userData.constructor === Object)) {
      console.log('User Data Mounted Not Empty');
      const { province } = this.$props.userData;
      if (this.$props.userData.street_address === '' || this.$props.userData.street_address === '' || this.$props.userData.municipality === '' || this.$props.userData.municipality === '') {
        this.isEditing = true;
      } else {
        const userSubpremise = this.$props.userData.floor !== '' ? `, ${this.$props.userData.floor} ${this.$props.userData.department}` : '';
        this.address = `${this.$props.userData.street_address} ${this.$props.userData.street_number}${userSubpremise}, ${this.$props.userData.municipality}, ${province}, ${this.$props.userData.country}`;
        // this.address = `${this.$props.userData.street_address} ${this.$props.userData.street_number}, ${this.$props.userData.municipality}, ${province}, ${this.$props.userData.country}`;
      }
    }
    const options = {};
    options.types = ['address'];
    options.componentRestrictions = { country: 'ar' };

    // eslint-disable-next-line
    this.autocomplete = new google.maps.places.Autocomplete(
      document.getElementById(this.autocompleteFieldId),
      options,
    );

    // eslint-disable-next-line
    this.geocoder = new google.maps.Geocoder();

    // eslint-disable-next-line
    this.autocompleteLsr = google.maps.event.addListener(this.autocomplete, 'place_changed', this.onPlaceChanged);
    // this.autocomplete.addListener('place_changed', this.onPlaceChanged);
  },
};
</script>

<style lang="scss">
.data-group.inlined {
  display: inline-block;
  margin: 0px 12px 0px 0;
}
.data-validation {
  text-align: left;
}
.data-validation h4 {
  font-weight: 600;
}
.data-group {
  margin: 16px 0;
}
.help-text {
  font-size: 11px;
  text-decoration: underline;
  color: hsl(216, 67%, 47%);
  cursor: pointer;
  font-weight: normal;
}

.imagen {
  width: 90px;
  margin: 12px auto;
}
.go-back-link {
  display: block;
  font-size: 13px;
}
#address-not-found {
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0px 5px 0px 0px;
}
.no-bottom-margin {
  margin-bottom: 0px;
}
.hide-pac-container .pac-container {
  display: none !important;
}
#apt-edit-field, #floor-edit-field {
  width: 49%;
  display: inline-block;
  margin-bottom: 4px;
  margin-top: 10px;
}
#floor-edit-field {
  margin-right: 2%;
}
</style>
